<template>
    <div id="leaderboard">
        <!--<h3 class="text-center my-5">În curând...</h3>-->

        <div class="d-flex flex-column my-5">
            <div v-for="(user,index) in users" v-bind:key="index"
                 class="d-flex flex-row py-1 py-md-2 w-100 user"
                 :class="userId == user.user_id ? 'my-user' : ''">
                <div class="nr my-auto">
                    <span>#</span>
                    <span v-text="user.position"></span>
                </div>
                <div class="profile-img mr-2 mr-lg-4 my-auto">
                    <img :src="user.profile_src" alt="">
                </div>
                <div class="d-flex flex-column flex-sm-row w-100">
                    <div class="name my-auto pl-2 pl-sm-0">
                        <span v-text="user.first_name"></span>
                        <span v-text="user.last_name" class="pl-2"></span>
                    </div>
                    <div class="stars ml-sm-auto  my-auto">
                        <span v-text="user.total_score"></span>
                        <img src="../../assets/imgs/profile/stele.png" alt="" class="text-center">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "Leaderboard",
        data() {
            return {
                baseUrl: null,
                terminalUID: null,
                accessToken: null,
                users: null,
                userId : this.$cookie.get('user_id'),
            }
        },
        mounted() {
            let self = this;
            this.baseUrl = this.$cookie.get('base-url');
            this.accessToken = this.$cookie.get('access-token');
            this.terminalUID = this.$cookie.get('terminal-uid');
            this.userId = this.$cookie.get('user_id');
            this.headers = {
                'terminal-uid': this.terminalUID,
                'Access-Control-Allow-Headers': 'Authorization',
                'Authorization': this.accessToken,
                'Content-Type': 'application/json',
            };
            setTimeout(function () {
                self.getLeaderboard();
            }, 300)
        },
        methods: {
            getLeaderboard() {
                let self = this;
                const headers = this.headers;
                axios.defaults.headers.common['Authorization'] = this.accessToken;
                axios.defaults.headers.common['terminal-uid'] = this.terminalUID;

                axios.get(
                    this.baseUrl + 'api/user/leaderboards',
                    {
                        headers
                    })
                    .then(function (response) {
                        self.users = response.data.result.users;

                        self.users.forEach((user) => {
                            user.profile_src = require('../../assets/imgs/profile/no-pic.png');
                            self.getProfileImage(user);
                        })
                    })
                    .catch(function (error) {
                        console.log('error', error);
                    });

            },
            getProfileImage(user) {
                this.accessToken = this.$cookie.get('access-token');
                this.terminalUID = this.$cookie.get('terminal-uid');
                let imageUrl = user.profile_pic_url;
                let self = this;

                const params = {
                    width: '50',
                    height: '50',
                    bypass_user: '1'
                };

                const headers = {
                    'terminal-uid': this.terminalUID,
                    'Access-Control-Allow-Headers': 'Authorization',
                    'Authorization': this.accessToken,
                };
                axios.defaults.headers.common['Authorization'] = this.accessToken;

                axios.get(
                    imageUrl,
                    {
                        params,
                        responseType: 'blob',
                        headers
                    })
                    .then(function (response) {
                        let reader = new FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onload = () => {
                            user.profile_src = reader.result;
                            self.$forceUpdate();
                        }
                    })
                    .catch(function (error) {
                        console.log('error', error);
                    });
            },
        }
    }
</script>

<style scoped>

</style>